import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import Vuelidate from 'vuelidate';
import App from './App';
import './registerServiceWorker';
import store from './store';
import router from './router';
import i18n from './plugins/i18n';

Vue.use( VueCompositionAPI );
Vue.use( Vuelidate );

Vue.config.productionTip = false;

new Vue({
    i18n,
    store,
    router,
    render: h => h( App )
}).$mount( '#app' );